class CardCarousel extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const carouselContainer = this.querySelector(".slides-container");
    const align = this.getAttribute("data-align") || "start";
    const loop = this.getAttribute("data-loop") === "true";
    const dragFree = this.getAttribute("data-drag-free") === "true";
    const scrollCount = this.getAttribute("data-slides-to-scroll") || 1;
    const controls = this.getAttribute("data-controls") === "true";

    this.embla = EmblaCarousel(carouselContainer, {
      align: align,
      loop: loop,
      dragFree: dragFree,
      skipSnaps: true,
      slidesToScroll: parseInt(scrollCount),
    });

    if (controls) {
      this.setupControls();
    }

    this.setupVideoHandlers();
  }

  setupVideoHandlers() {
    const videos = this.querySelectorAll('.custom-video');

    if (!videos.length) return;

    videos.forEach((video) => {
      video.addEventListener('click', () => {
        if (video.paused) {
          video.controls = true;
          setTimeout(() => {
            video.play().catch((err) => {
              console.warn('Video play failed:', err);
            });
          }, 300);
        } else {
          setTimeout(() => {
            video.pause();
          }, 300);
        }
      });
    });
  }

  setupControls() {
    const prevBtn = this.querySelector(".embla__button--prev");
    const nextBtn = this.querySelector(".embla__button--next");

    if (prevBtn && nextBtn) {
      prevBtn.addEventListener("click", () => this.embla.scrollPrev());
      nextBtn.addEventListener("click", () => this.embla.scrollNext());

      this.embla.on("select", () => {
        prevBtn.disabled = !this.embla.canScrollPrev();
        nextBtn.disabled = !this.embla.canScrollNext();
      });

      prevBtn.disabled = !this.embla.canScrollPrev();
      nextBtn.disabled = !this.embla.canScrollNext();
    }
  }

  disconnectedCallback() {
    if (this.embla) {
      this.embla.destroy();
      this.embla = null;
    }
  }
}

customElements.define("card-carousel", CardCarousel);